import {
  Component,
  ElementRef,
  Inject,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fabric } from 'fabric';
import { DcoCreativesService } from 'src/app/core/services/dco/dco-creatives.service';

@Component({
  selector: 'app-creative-preview',
  templateUrl: './creative-preview.component.html',
  styleUrl: './creative-preview.component.scss'
})
export class CreativePreviewComponent
  implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('previewCanvas', { static: true })
  previewCanvasRef!: ElementRef<HTMLCanvasElement>;

  private canvas!: fabric.Canvas;

  canvasWidth = 300;
  canvasHeight = 250;
  meta!: any;
  component!: string;
  creativePreview;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreativePreviewComponent>,
    private dcoCreativesService: DcoCreativesService
  ) {}

  ngOnInit(): void {
    this.dialogRef.updatePosition({
      top: '21em',
      left: '40%',
      right: '10em'
    });

    if (this.data?.width && this.data?.height) {
      this.canvasWidth = this.data.width;
      this.canvasHeight = this.data.height;
    }

    this.meta = this.data?.meta || this.data;
    this.component = this.data?.component || '';
  }

  ngAfterViewInit(): void {
    this.initCanvas();
    this.renderMeta();
  }

  ngOnDestroy(): void {
    this.canvas?.dispose();
  }

  private initCanvas(): void {
    this.canvas = new fabric.Canvas(this.previewCanvasRef.nativeElement, {
      backgroundColor: '#ffffff',
      preserveObjectStacking: true,
      selection: false
    });

    this.canvas.setWidth(this.canvasWidth);
    this.canvas.setHeight(this.canvasHeight);
    this.canvas.off();
  }

  private renderMeta(): void {
    if (!this.meta) return;

    if(this.component === 'dcoCreatives') {
      let previewData = {
        meta: this.meta,
        product_feed_id: this.data.product_feed_id
      }
      this.dcoCreativesService.getCreativePreview( this.data.globalParams, previewData).subscribe((res) => {
        this.creativePreview ={
          version: "5.3.0",
          objects: [...res.meta]
        }
        this.preview();
      });
    }
    else{
      this.preview();
    }
  }
  
  private stripCrossOriginFromMeta(meta: any): any {
    if (!meta) return meta;
    const out = { ...meta };
    if (Array.isArray(out.objects)) {
      out.objects = out.objects.map((obj: any) => this.stripCrossOriginFromObject(obj));
    }
    return out;
  }

  private stripCrossOriginFromObject(obj: any): any {
    if (!obj) return obj;
    const copy = { ...obj };
    if (copy.type === 'image') {
      copy.crossOrigin = null;
    }
    if (Array.isArray(copy.objects)) {
      copy.objects = copy.objects.map((o: any) => this.stripCrossOriginFromObject(o));
    }
    return copy;
  }

  private preview() {
    this.canvas.clear();
    let previewMeta = this.component === 'dcoCreatives' ? this.creativePreview : this.meta;
    const metaWithoutCors = this.stripCrossOriginFromMeta(previewMeta);

    this.canvas.loadFromJSON(metaWithoutCors, () => {
      this.canvas.getObjects().forEach((obj: any) => {

        obj.selectable = false;
        obj.evented = false;
        obj.lockMovementX = true;
        obj.lockMovementY = true;
        obj.lockScalingX = true;
        obj.lockScalingY = true;
        obj.lockRotation = true;
        obj.hasControls = false;
        obj.hasBorders = false;
        obj.editable = false;

        if (obj.type === 'textbox') {
          obj.height = undefined;
          obj.scaleX = 1;
          obj.scaleY = 1;
          obj.initDimensions();
        }

        obj.setCoords();
      });

      this.canvas.renderAll();
    });
  }
}